<template>
  <div class="building-status-editor">
    <div class="row">
      <div class="col-md-6 col-lg-6 col-xl-6 mb-2">
        <div class="label">วันเริ่มต้น</div>
        <date-picker
          :value="value.startAt"
          :disabled="disabled"
          class="w-100"
          @input="handleFieldChange('startAt', $event)"
        ></date-picker>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6 mb-2">
        <div class="label">วันสิ้นสุด</div>
        <date-picker
          :value="value.endAt"
          :disabled="disabled"
          class="w-100"
          @input="handleFieldChange('endAt', $event)"
        ></date-picker>
      </div>
    </div>
    <div class="mb-3">
      <div class="label">สถานะ</div>
      <el-select
        :value="value.status"
        :disabled="disabled"
        @input="handleFieldChange('status', $event)"
      >
        <el-option
          v-for="status in instructionStatus"
          :key="status.value"
          :label="status.label"
          :value="status.value"
        ></el-option>
      </el-select>
    </div>
    <hr />
    <div class="detail-list">
      <div class="label">
        <strong>รายการงาน</strong>
      </div>
      <instruction-task
        v-for="(task, index) in value.tasks"
        :key="index"
        :value="task"
        :disabled="disabled"
        class="mb-3"
        @input="handleTaskChange(index, $event)"
        @remove="handleClickRemoveTaskButton(index)"
      ></instruction-task>
      <sc-button
        v-if="!disabled"
        class="w-100 mt-4"
        size="sm"
        @click="handleClickAddTaskButton"
        >เพิ่มงาน</sc-button
      >
    </div>
    <hr />
    <div class="mb-3">
      <div class="label">ความคืบหน้าโดยรวม (%)</div>
      <el-input
        :value="value.overallProgress"
        :disabled="disabled"
        @input="handleFieldChange('overallProgress', $event)"
      ></el-input>
    </div>
    <div class="mb-3">
      <div class="label">อัพเดทล่าสุดเมื่อ</div>
      <date-picker
        :value="value.updatedAt"
        :disabled="disabled"
        class="w-100"
        @input="handleFieldChange('updatedAt', $event)"
      ></date-picker>
    </div>
    <div class="mb-3">
      <div class="label">รูปการก่อสร้าง</div>
      <album-picker
        :value="value.imageFiles"
        :disabled="disabled"
        :image-urls="imageUrls"
        :max-number-of-images="5"
        @input="handleFieldChange('imageFiles', $event)"
        @removeImage="handleClickRemoveImageButton"
      ></album-picker>
    </div>
  </div>
</template>

<script>
import { Select, Option, Input } from "element-ui"
import DatePicker from "@/lib/components/DatePicker"
import ScButton from "@/lib/components/ScButton"
import InstructionTask from "./InstructionTask"
import AlbumPicker from "./AlbumPicker"

export default {
  components: {
    DatePicker,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    InstructionTask,
    ScButton,
    AlbumPicker,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    imageUrls: {
      type: null,
      default: undefined,
    },
    disabled: {
      type: null,
      default: undefined,
    },
  },
  data() {
    const instructionStatus = [
      { value: "START", label: "เริ่มต้น" },
      { value: "INPROGRESS", label: "กำลังก่อสร้าง" },
      { value: "COMPLETED", label: "เสร็จสิ้น" },
    ]

    return {
      date: null,
      instructionStatus,
    }
  },
  methods: {
    handleFieldChange(key, fieldValue) {
      this.$emit("input", { ...this.value, [key]: fieldValue })
    },
    handleTaskChange(index, task) {
      const tasks = [...this.value.tasks]
      tasks[index] = task
      this.$emit("input", { ...this.value, tasks })
    },
    handleClickAddTaskButton() {
      this.$emit("input", {
        ...this.value,
        tasks: [...this.value.tasks, { name: "", progress: 0, startAt: null }],
      })
    },
    handleClickRemoveTaskButton(index) {
      this.$emit("input", {
        ...this.value,
        tasks: this.value.tasks.filter((t, i) => i !== index),
      })
    },
    handleClickRemoveImageButton(index) {
      this.$emit("removeImage", index)
    },
  },
}
</script>

<style lang="scss" scoped>
.label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}
</style>
